import { Typography } from "@material-ui/core";
import React from "react";
import "./Loading.css";

const Loading = ({ violated }) => {
	return (
		<div className="loading-screen">
			<img src="/logo.png" alt="josh-logo" />
			{violated ? (
				<Typography variant="h5">
					Your test has ended because you violated the rules. You will be scored based on
					your attempted questions.
				</Typography>
			) : null}
		</div>
	);
};

export default Loading;
